export const sanitizePsychStats = (psychStats: any) => {
   let copyPsychStats = JSON.parse(JSON.stringify(psychStats));
   if(psychStats && psychStats.length){
      copyPsychStats = copyPsychStats.sort((a, b) => {
         const codeA = a.scale_code ?? null;
         const codeB = b.scale_code ?? null;

         if (codeA === null && codeB === null) {
            return 0;
         }
         if (codeA === null) {
            return 1; // Place nulls at the end
         }
         if (codeB === null) {
            return -1; // Place nulls at the end
         }
         // Reverse the order for descending sort
         return codeB.localeCompare(codeA);
      });
      copyPsychStats.forEach(stats =>{
         Object.keys(stats)?.forEach(key =>{
            if(!psychStatDataCol.has(key)){
               delete stats[key];
            }
         })
      })
   }
   return copyPsychStats
}

export const psychStatDataCol = new Set([
   'a', 
   'b', 
   'g', 
   'b1', 
   'b2', 
   'b3', 
   'b4', 
   'b5', 
   'b6',    
])

export const psychThresholdParams = ['b','g','b1','b2','b3','b4','b5','b6'];

export const psychStatsColumns:string[] = [ // would prefer to get this from the data, but this is fine for now
   'item_version' 
   , 'scale_code'
   , 'calib_year'
   , 'psych_run_id'
   , 'created_on'
   , 'a' , 'b', 'g'
   , 'b1', 'b2', 'b3', 'b4', 'b5', 'b6'
   , 'diff', 'item_mean', 'pbis', 'cpbis', 'exposure'
];